// The name an account already carries, for onboarding's "Your name": Apple and
// Google sign-in put it in the user's metadata (given_name, full_name, name).
// An email account has none, and the field's given-name autofill does the rest.

/** The first name in a Supabase user's metadata; '' when it has none. */
export function firstNameOf(user: { user_metadata?: Record<string, unknown> } | null | undefined): string {
  const meta = user?.user_metadata ?? {}
  for (const key of ['given_name', 'first_name', 'full_name', 'name']) {
    const v = meta[key]
    if (typeof v === 'string' && v.trim()) {
      const first = key === 'full_name' || key === 'name' ? v.trim().split(/\s+/)[0] : v.trim()
      // An email address isn't a name (some providers put one there).
      if (!first.includes('@')) return first.slice(0, 40)
    }
  }
  return ''
}
